const nav = document.querySelector('header');

nav.addEventListener('mouseover', function() {
  const topLinks = document.querySelector('.top-links ul.site-nav');
  topLinks.style.borderRight = '#262428 1.5px solid';
});

nav.addEventListener('mouseout', function() {
  const topLinks = document.querySelector('.top-links ul.site-nav');
  topLinks.style.borderRight = '#fff 1.5px solid';
});

window.addEventListener('load', function() {
  console.log('loaded!')
  if (window.scrollY >= 47) {
    const topLinks = document.querySelector('.top-links ul.site-nav');
    const header = document.querySelector('header');
    topLinks.style.borderRight = '#262428 1.5px solid';
    header.style.boxShadow = '0 2px 2px -2px rgba(0,0,0,.2)';
    topLinks.classList.add('scrolled');
  }
});

window.addEventListener('scroll', function() {
  if (window.scrollY >= 47) {
    const topLinks = document.querySelector('.top-links ul.site-nav');
    const header = document.querySelector('header');
    topLinks.style.borderRight = '#262428 1.5px solid';
    header.style.boxShadow = '0 2px 2px -2px rgba(0,0,0,.2)';
    topLinks.classList.add('scrolled');
  }

  if (window.scrollY < 47) {
    const topLinks = document.querySelector('.top-links ul.site-nav');
    const header = document.querySelector('header');
    topLinks.style.borderRight = '#fff 1.5px solid';
    header.style.boxShadow = 'none';
    topLinks.classList.remove('scrolled');
  }
});